import {
  axiosInstance,
  getConfiguration,
  Team,
} from '@foxtrotplatform/platform-micro-site-core';
import { AxiosRequestConfig } from 'axios';

import { DeveloperAppConfig } from '../../common/config/developerAppConfig';
import { OrganizationCreate } from '../../components/Organization/CreateOrganization/types';
import { TeamType } from '../enums';
import { DeveloperOrganization, Tenant } from '../providers/types';
import { ApiError, ApiResponse, IdResponse, SuccessResponse } from './types';
export interface OrganizationResponse extends IdResponse {
  requiresEmailValidation: boolean;
}

export const getOrgDeveloperTeams = async (orgId: string): Promise<Team[]> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/${orgId}/team/all`,
    method: 'get',
  };
  const response: ApiResponse<any> = await axiosInstance(request);

  const teams: Team[] = response.data
    .filter(
      (x: any) =>
        x.teamInstance !== TeamType.organization &&
        x.teamInstance !== TeamType.organizationMembers
    )
    .map((x: { teamId: string; teamName: string; teamInstance: TeamType }) => {
      return {
        id: x.teamId,
        name: x.teamName,
      };
    });

  return teams;
};

export const createOrganization = async ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  id,
  ...organization
}: OrganizationCreate): Promise<OrganizationResponse> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  try {
    const request: AxiosRequestConfig = {
      url: `${config.baseApiUrl}/organization/`,
      method: 'post',
      data: {
        ...organization,
        context: 'developer',
      },
    };

    const { data }: ApiResponse<OrganizationResponse> = await axiosInstance(
      request
    );

    return data;
  } catch (e) {
    if (ApiError.isApiError(e)) {
      throw new ApiError(e);
    }

    throw e;
  }
};

export const verifyOtpCode = async (
  organizationId: string,
  code: string
): Promise<SuccessResponse> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/${organizationId}/verify`,
    method: 'post',
    data: {
      code,
    },
  };
  try {
    const { data }: ApiResponse<SuccessResponse> = await axiosInstance(request);

    return data;
  } catch (e) {
    if (ApiError.isApiError(e)) {
      throw new ApiError(e);
    }

    throw e;
  }
};
export const resendOtpCode = async (
  organizationId: string
): Promise<SuccessResponse> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/${organizationId}/verify/send`,
    method: 'post',
    data: {
      regenerate: false,
    },
  };

  try {
    const { data }: ApiResponse<SuccessResponse> = await axiosInstance(request);

    return data;
  } catch (e) {
    if (ApiError.isApiError(e)) {
      throw new ApiError(e);
    }

    throw e;
  }
};

export const getOrganizationById = async (
  organizationId: string
): Promise<DeveloperOrganization> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/${organizationId}`,
    method: 'get',
  };

  const { data }: ApiResponse<DeveloperOrganization> = await axiosInstance(
    request
  );

  return data;
};

export const getOrganizationTenant = async (orgId: string): Promise<Tenant> => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const request: AxiosRequestConfig = {
    url: `${config.baseApiUrl}/organization/${orgId}/tenant?type=DEVELOPMENT`,
    method: 'get',
  };
  const { data }: ApiResponse<Tenant> = await axiosInstance(request);

  return data[0];
};
